import { render, staticRenderFns } from "./PersonInterestsForm.vue?vue&type=template&id=54edb958"
import script from "./PersonInterestsForm.vue?vue&type=script&lang=ts"
export * from "./PersonInterestsForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports